import { TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { BaseTablePropsType } from "../../../types/container.type";
import { formatDate } from "../../../helpers/dateFormatter";
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";

export const OutstandingLoanBalanceReportTable: React.FC<
	BaseTablePropsType
> = ({ rows }) => {
	const outstandingLoanBalanceTableHeaders = [
		"Customer Name",
		"Repayment Start Date",
		"Maturity Date",
		"Disbursed Amount",
		"Total Payable",
		"Amount Paid",
		"Outstanding Loan Balance",
	];
	return (
		<BaseTable headers={outstandingLoanBalanceTableHeaders}>
			<TableBody>
				{rows?.map((row, index) => {
					return (
						<TableRow key={index}>
							<TableCell>{row?.customerName}</TableCell>
							<TableCell>
								{formatDate(row?.firstRepaymentDate, false)}
							</TableCell>
							<TableCell>{formatDate(row?.maturityDate, false)}</TableCell>
							<TableCell>
								{formatAmountDisplay(row?.amountDisbursed ?? 0)}
							</TableCell>
							<TableCell>
								{formatAmountDisplay(row?.totalPayable ?? 0)}
							</TableCell>
							<TableCell>{formatAmountDisplay(row?.amountPaid ?? 0)}</TableCell>
							<TableCell>
								{formatAmountDisplay(row?.outstandingLoanBalance ?? 0)}
							</TableCell>
						</TableRow>
					);
				})}
			</TableBody>
		</BaseTable>
	);
};
